// extracted by mini-css-extract-plugin
module.exports = {"largeTag":"Tag_largeTag__PEQPm","tag":"Tag_tag__UP9aK","loadingSpinner":"Tag_loadingSpinner__nRI5o"};